import React from "react";
import { createRoot } from "react-dom/client";

import "./index.css";
import "./mui4migrate.css";
import {
  initGlobalValues,
  setSWRegistration,
  setNotifPermission,
  authProviders,
} from "./General/globals";
import ServiceBase from "./Services/_serviceBase";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import App from "./App";
import { RemoveLastDialog } from "./General/commonFunctions";
import "devextreme/dist/css/dx.light.css";
import "devexpress-gantt/dist/dx-gantt.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { LogLevel } from "@azure/msal-browser";
import { GoogleOAuthProvider } from "@react-oauth/google";

async function startApp() {
  let _serviceBase = new ServiceBase();
  let appOptions = await _serviceBase.loadFromFileURL(
    "init.json?ver=" + new Date().toISOString()
  );
  let _offLayout = await _serviceBase.loadFromFileURL(
    "offline.json?ver=" + new Date().toISOString()
  );

  initGlobalValues(appOptions, _offLayout);

  const root = createRoot(document.getElementById("root"));

  //////////////////////////////////// MSAL configuration////////////////////////////////////

  const msalInstance = new PublicClientApplication({
    auth: {
      clientId: authProviders?.MSAL?.client_id,
      authority: authProviders?.MSAL?.authority,
      redirectUri: authProviders?.MSAL?.redirect_uri,
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level, message) => {},
        logLevel: LogLevel.Info,
      },
    },
  });
  ///////////////////////////////////////GOOGLE///////////////////////////////////////////
  const googleClientId = authProviders?.GOOGLE?.client_id || "";
  /////////////////////////////////////////////////////////////////////////////////////
  root.render(
    <GoogleOAuthProvider clientId={googleClientId}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </GoogleOAuthProvider>
  );
}

startApp();

window.addEventListener("load", () => window.history.pushState({}, ""));
window.addEventListener("popstate", (e) => RemoveLastDialog(e));

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;
    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event) => {
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
navigator.serviceWorker &&
  navigator.serviceWorker.ready.then(function (registration) {
    setSWRegistration(registration);
  });

showNotification();

function showNotification() {
  "Notification" in window &&
    Notification.requestPermission(function (result) {
      if (result === "granted") {
        setNotifPermission(true);
      }
    });
}
